<cc-apps-tool-bar *ngIf="app" [app]="app" (add)="onAddForm()" [canAdd]="canAdd"></cc-apps-tool-bar>
<cc-form-list [canAddForm]="canAdd" [template]="app"></cc-form-list>
